import { Unionize } from "./generic";

export type SolvesControl = {
  dataT: string;
  onClick: () => void;
  disabled: boolean;
  loading: boolean;
  message: string;
};

export type SolveAlert = {
  dataT: string;
  severity: string;
  message: string;
};

export type SolveStepDisplay = {
  id: string;
  text: string;
  icon: any;
  className: string;
};

export const WorkflowQuality = ["express", "balanced", "extended"] as const;
export type WorkflowQuality = Unionize<typeof WorkflowQuality>;
